import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-radio-input',
  styleUrls: ['./radio-input.component.scss'],
  imports: [ReactiveFormsModule],
  template:
    '<label>{{ text }}<input [id]="id" [formControl]="control" type="radio" [value]="value" /></label>',
  standalone: true,
})
export class RadioInputComponent {
  @Input()
  id: string;

  @Input()
  name: string;

  @Input()
  text: string;

  @Input()
  value: any;

  @Input()
  control: FormControl;
}
